module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-bottom-nav', {
    staticClass: "mildly_purple",
    attrs: {
      "value": true,
      "active": _vm.current
    },
    on: {
      "update:active": function($event) {
        _vm.current = $event
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "value": "me"
    }
  }, [_c('span', [_vm._v("me")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "discover"
    }
  }, [_c('span', [_vm._v("discover")]), _vm._v(" "), _c('v-icon', [_vm._v("dashboard")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "vault"
    }
  }, [_c('span', [_vm._v("Vault")]), _vm._v(" "), _c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "value": "consents"
    }
  }, [_c('span', [_vm._v("Consents")]), _vm._v(" "), _c('v-icon', [_vm._v("swap_calls")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b4aeba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterNavigation.vue
// module id = 334
// module chunks = 2